import { render, staticRenderFns } from "./ShiftsTable.vue?vue&type=template&id=40ddd647"
import script from "./ShiftsTable.vue?vue&type=script&lang=js"
export * from "./ShiftsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports